export default __webpack_public_path__ + "static/why_choose_react-eb8235dacc029e953f31572e9cfbaee8.webp";